export class Fotos{
	TypeID;
	ID: number;
	url;
	nota;	
	ImageName;
	ImageExtension
  	Base64;
  	url_front;
	extension;
	ProductID;  
	imageProductID;
	constructor(){}		
}